export const SET_APP_DATA = 'SET_APP_DATA';
export const RESET_APP_DATA = 'RESET_APP_DATA';
export const SET_APP_CLOSE = 'SET_APP_CLOSE';
export const SET_QUALIFY_VEHICLE_QUESTIONS = 'SET_QUALIFY_VEHICLE_QUESTIONS'
export const RESET_QUALIFY_VEHICLE_QUESTIONS = 'RESET_QUALIFY_VEHICLE_QUESTIONS'
export const APP_SET_GRSF_TOKEN = 'APP_SET_GRSF_TOKEN'
export const APP_RESET_GRSF_TOKEN = 'APP_RESET_GRSF_TOKEN';

export const SET_QUERY_PARAMS = 'SET_QUERY_PARAMS'
export const RESET_QUERY_PARAMS = 'RESET_QUERY_PARAMS'